document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE DRAWER ──
  var drawer = document.getElementById('mazDrawer');
  var overlay = document.getElementById('mazOverlay');
  var close = document.getElementById('mazClose');
  var ham = document.getElementById('mazHam');

  function openDrawer() { if(drawer)drawer.classList.add('open'); if(overlay)overlay.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeDrawer() { if(drawer)drawer.classList.remove('open'); if(overlay)overlay.classList.remove('show'); document.body.style.overflow=''; }
  if(ham) ham.addEventListener('click', openDrawer);
  if(close) close.addEventListener('click', closeDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);

  // ── STICKY HEADER SHADOW ──
  var nav = document.querySelector('.nav');
  if(nav) window.addEventListener('scroll', function(){ nav.classList.toggle('scrolled', window.scrollY > 10); }, {passive:true});

  // ── FAQ ──
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = this.closest('.faq-item');
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); });
      if(!open) item.classList.add('open');
    });
  });

  // ── SCROLL REVEAL ──
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); });
  }, {threshold: 0.07});
  document.querySelectorAll('.fade-in').forEach(function(el){ obs.observe(el); });

  // ── QTY BUTTONS ──
  document.querySelectorAll('.qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var inp = this.closest('.qty-ctrl').querySelector('.qty-inp');
      if(!inp) return;
      var v = parseInt(inp.value)||1;
      var d = this.dataset.action==='minus' ? -1 : 1;
      inp.value = Math.max(1, v+d);
      inp.dispatchEvent(new Event('change'));
    });
  });

  // ── PD THUMB ──
  document.querySelectorAll('.pd-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.pd-thumb').forEach(function(x){x.classList.remove('active');});
      this.classList.add('active');
      var src = this.dataset.src;
      if(src){ var m=document.querySelector('.pd-img-main img'); if(m) m.src=src; }
    });
  });

  // ── CART AJAX ──
  window.mazUpdateCart = function(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(){ window.location.reload(); });
  };

  // ── TRUST BAR DRAG SCROLL ──
  var tb = document.querySelector('.trust-bar');
  if(tb){
    var isDragging=false, startX, scrollLeft;
    tb.addEventListener('mousedown', function(e){ isDragging=true; startX=e.pageX-tb.offsetLeft; scrollLeft=tb.scrollLeft; });
    tb.addEventListener('mousemove', function(e){ if(!isDragging)return; e.preventDefault(); tb.scrollLeft=scrollLeft-(e.pageX-tb.offsetLeft-startX); });
    tb.addEventListener('mouseup', function(){ isDragging=false; });
    tb.addEventListener('mouseleave', function(){ isDragging=false; });
  }
});
